import { EventEmitter, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Offer } from 'src/app/models/Offer';
import { TranslatableString } from 'src/app/models/TranslatableString';
import { Field } from 'src/app/modules/home/google-maps/offer-filter/Field';
import { OffersService } from './offers.service';

@Injectable({
  providedIn: 'root',
})
export class FilterTableService {
  // @Input() selectedOffers: Array<Offer>;
  // @Input() isRentable: boolean;
  updateOffers: EventEmitter<any>;
  selectedOffers: Array<Offer>;
  allOffers: Array<Offer>;
  private isFirstClickRegions = true;
  private isFirstClickType = true;
  private isFirstClickSaleOption = true;
  priceFrom: string;
  priceTo: string;
  areaFrom: string;
  areaTo: string;
  id: string;

  regionField: Field;
  regions: Array<Field>;

  private centralAreas = [
    'ВИНС',
    'Генералите',
    'Гръцка махала',
    'Общината',
    'Червен площад',
    'Чаталджа',
    'Нептун',
    'Образцов дом',
    'Централна поща',
    'Бизнес хотел',
    'Операта',
    'ЖП гара',
  ];

  typeField: Field;
  types: Array<{ type: Field; subTypes: Array<Field> }>;
  currentlySelectedType: { type: Field; subTypes: Array<Field> };

  salesSelected: boolean;
  rentsSelected: boolean;
  currentSelection: string;
  constructor(private offS: OffersService, private router: Router) {
    this.regionField = new Field(
      new TranslatableString('Area', 'Area', 'Район', 'Район'),
      false
    );
    this.typeField = new Field(
      new TranslatableString('Type', 'Type', 'Тип', 'Тип'),
      false
    );
    this.salesSelected = true;
    this.rentsSelected = true;
    this.regions = [];
    this.types = [];
    this.selectedOffers = [];
    this.updateOffers = new EventEmitter();
    this.init();
  }

  private init() {
    this.offS.getOffers().subscribe((offers: Array<Offer>) => {
      this.currentSelection = this.router.url.includes('rents')
        ? 'rents'
        : 'sales';
      this.rentsSelected = this.router.url.includes('rents');
      this.salesSelected = !this.rentsSelected;
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.resetOnRouteChange();
        });
      this.allOffers = [];
      offers.forEach((off: any) => {
        this.allOffers.push(new Offer(off));
      });

      const dummyRegions = [];
      const dummyTypes = [];
      const dummySubtypes = [];
      this.allOffers.forEach((offer: Offer) => {
        if (!dummyRegions.includes(offer.area.value)) {
          dummyRegions.push(offer.area.value);
          this.regions.push(
            new Field(
              new TranslatableString(
                offer.area.value,
                offer.area.valueEn,
                offer.area.valueBg,
                offer.area.valueRu
              )
            )
          );
        }
        if (!dummyTypes.includes(offer.type.value)) {
          dummyTypes.push(offer.type.value);
          this.types.push({
            type: new Field(
              new TranslatableString(
                offer.type.value,
                offer.type.valueEn,
                offer.type.valueBg,
                offer.type.valueRu
              )
            ),
            subTypes: [
              new Field(
                new TranslatableString(
                  offer.subType.value,
                  offer.subType.valueEn,
                  offer.subType.valueBg,
                  offer.subType.valueRu
                )
              ),
            ],
          });
          dummySubtypes.push(offer.subType.value);
        } else {
          if (!dummySubtypes.includes(offer.subType.value)) {
            dummySubtypes.push(offer.subType.value);
            const typeIndex = dummyTypes.indexOf(offer.type.value);
            this.types[typeIndex].subTypes.push(
              new Field(
                new TranslatableString(
                  offer.subType.value,
                  offer.subType.valueEn,
                  offer.subType.valueBg,
                  offer.subType.valueRu
                )
              )
            );
          }
        }
      });

      this.regions.sort((x: Field, y: Field) => {
        return x.value.valueBg < y.value.valueBg ? -1 : 1;
      });

      this.types.forEach((type: { type: Field; subTypes: Array<Field> }) => {
        type.subTypes.sort((x: Field, y: Field) => {
          return x.value.valueBg < y.value.valueBg ? -1 : 1;
        });
      });
      this.currentlySelectedType = this.types[0];
      this.types[0].type.isSelected = true;
      this.filterInitialOffers();
      this.updateOffers.emit(this.selectedOffers);
    });
  }
  resetOnRouteChange() {
    let newRoute = '';
    if (this.router.url.includes('rents')) {
      newRoute = 'rents';
      this.updateOffers.emit();
    }
    if (this.router.url.includes('sales')) {
      newRoute = 'sales';
      this.updateOffers.emit();
    }

    if (
      !this.allOffers ||
      newRoute === this.currentSelection ||
      newRoute === ''
    ) {
      return;
    }
    this.currentSelection = newRoute;
    this.rentsSelected = newRoute === 'rents';
    this.salesSelected = !this.rentsSelected;
    this.types.forEach((field: { type: Field; subTypes: Array<Field> }) => {
      field.type.isSelected = true;
      field.subTypes.forEach((subType: Field) => {
        subType.isSelected = true;
      });
    });
    this.regions.forEach((region: Field) => {
      region.isSelected = true;
    });
    this.priceFrom = '';
    this.priceTo = '';
    this.areaFrom = '';
    this.areaTo = '';
    this.id = '';
    this.isFirstClickRegions = true;
    this.isFirstClickType = true;
    this.isFirstClickSaleOption = true;
    this.filterOffers();
    this.updateOffers.emit();
  }

  filterInitialOffers() {
    this.selectedOffers = [];
    this.allOffers.forEach((offer: Offer) => {
      this.checkSalesAndRents(offer);
    });
  }

  // used only for initial offer setup
  private checkSalesAndRents(currentOffer: Offer) {
    if (this.salesSelected && currentOffer.isSellable) {
      this.selectedOffers.push(currentOffer);
    }
    if (this.rentsSelected && currentOffer.isRentable) {
      this.selectedOffers.push(currentOffer);
    }
  }

  selectOfferType(type: { type: Field; subTypes: Array<Field> }) {
    this.currentlySelectedType = type;
  }

  toggleSelected(field: Field, toggleType: string) {
    if (this.isFirstClickRegions && toggleType === 'region') {
      this.isFirstClickRegions = false;
      this.regions.forEach((f: Field) => {
        f.isSelected = false;
      });
      field.isSelected = true;
    } else if (this.isFirstClickType && toggleType === 'type') {
      this.isFirstClickType = false;
      this.types.forEach((type) => {
        type.subTypes.forEach((subType) => {
          subType.isSelected = false;
        });
      });
      field.isSelected = true;
    } else {
      field.isSelected = !field.isSelected;
    }
    this.checkCenterAreaClick(field, toggleType);
    this.filterOffers();
  }

  private checkCenterAreaClick(field: Field, toggleType: string) {
    if (toggleType === 'region' && field.value.valueBg === 'Център') {
      this.regions
        .filter((f: Field) => {
          return this.centralAreas.includes(f.value.valueBg);
        })
        .forEach((f: Field) => {
          f.isSelected = field.isSelected;
        });
    }
  }

  toggleSales() {
    if (this.isFirstClickSaleOption) {
      this.isFirstClickSaleOption = false;
      this.salesSelected = true;
      this.rentsSelected = false;
    } else {
      this.salesSelected = !this.salesSelected;
    }
    this.filterOffers();
  }

  toggleRents() {
    if (this.isFirstClickSaleOption) {
      this.isFirstClickSaleOption = false;
      this.salesSelected = false;
      this.rentsSelected = true;
    } else {
      this.rentsSelected = !this.rentsSelected;
    }
    this.filterOffers();
  }

  filterOffers() {
    this.selectedOffers = [];
    for (let i = 0; i < this.allOffers.length; i++) {
      const currentOffer = this.allOffers[i];
      if (this.checkIfOfferIsSelected(currentOffer)) {
        this.selectedOffers.push(currentOffer);
      }
    }

    this.selectedOffers = this.selectedOffers.filter((offer: Offer) => {
      return (
        (offer.isSellable && this.salesSelected) ||
        (offer.isRentable && this.rentsSelected)
      );
    });
  }

  private checkIfOfferIsSelected(o: Offer): boolean {
    return (
      this.checkPrice(o) &&
      this.checkArea(o) &&
      this.checkRegion(o) &&
      this.checkSubtypeSelected(o) &&
      this.checkOfferID(o)
    );
  }

  private checkPrice(currentOffer: Offer) {
    const priceFrom = Number(this.priceFrom);
    const priceTo = Number(this.priceTo);
    const offerPrice = Number(currentOffer.price.replace(' ', ''));

    if (priceFrom && offerPrice < priceFrom) {
      return false;
    }
    if (priceTo && offerPrice > priceTo) {
      return false;
    }

    return true;
  }

  private checkArea(currentOffer: Offer) {
    const areaFrom = Number(this.areaFrom);
    const areaTo = Number(this.areaTo);
    const offerArea = Number(currentOffer.space);

    if (areaFrom && offerArea < areaFrom) {
      return false;
    }

    if (areaTo && offerArea > areaTo) {
      return false;
    }
    return true;
  }

  private checkRegion(currentOffer: Offer) {
    const selectedRegions = this.regions.filter((region: Field) => {
      return (
        region.isSelected && region.value.value === currentOffer.area.value
      );
    });

    if (selectedRegions.length === 0) {
      return false;
    }
    return true;
  }

  private checkSubtypeSelected(currentOffer: Offer) {
    const elementsMatching = [];
    this.types.forEach((type: { type: Field; subTypes: Array<Field> }) => {
      const selected = type.subTypes.filter((subType: Field) => {
        return (
          subType.isSelected &&
          subType.value.valueEn === currentOffer.subType.valueEn
        );
      });
      elementsMatching.push(...selected);
    });

    if (elementsMatching.length === 0) {
      return false;
    }
    return true;
  }

  private checkOfferID(currentOffer: Offer) {
    const id = Number(this.id);
    if (id && currentOffer.id !== id) {
      return false;
    }
    return true;
  }
}
